package dev.akshaychordiya.pages.articles

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initGoWithTheKotlinFlowPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("articles/GoWithTheKotlinFlow.md", FrontMatterElement.Builder { addScalar("title", "Go with the Kotlin Flow"); addScalar("date", "2020-03-29"); addScalar("description", "Kotlin Flow is an implementation of Reactive Stream specification made on top of coroutines and channels for Kotlin."); addScalar("originalUrl", "https://medium.com/@aky/go-with-the-kotlin-flow-7067564665a3"); addScalar("originalName", "Medium"); addScalar("image", "/images/articles/go-with-the-kotlin-flow/1hLp43QwJDJNIG6qiziLM8Q.webp"); }))
}

@Page("/articles/go-with-the-kotlin-flow")
@Layout(".components.layouts.ArticleLayout")
@Composable
fun GoWithTheKotlinFlowPage() {
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.graphics.Image("/images/articles/go-with-the-kotlin-flow/1hLp43QwJDJNIG6qiziLM8Q.webp", "")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("Photo by ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://unsplash.com/@berter306?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText") {
                org.jetbrains.compose.web.dom.Text("Andrew Bertram")
            }
            org.jetbrains.compose.web.dom.Text(" on ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://unsplash.com/?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText") {
                org.jetbrains.compose.web.dom.Text("Unsplash")
            }
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("content") }) {
        org.jetbrains.compose.web.dom.Text("Content")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/google-developer-experts/go-with-the-kotlin-flow-7067564665a3") {
                org.jetbrains.compose.web.dom.Text("Go with the Kotlin Flow 🌊")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Diving deeper into Kotlin Flow 🏊‍♂️ [Coming soon]")
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/@aky/migrating-legacy-code-to-kotlin-flow-3f3e1854925") {
                org.jetbrains.compose.web.dom.Text("Migrating from legacy code to Kotlin Flow 🚚")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Flow on Android 🤖 [Coming soon]")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("preface") }) {
        org.jetbrains.compose.web.dom.Text("Preface")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Kotlin Flow is an implementation of ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/reactive-streams/reactive-streams-jvm/blob/v1.0.3/README.md#specification") {
            org.jetbrains.compose.web.dom.Text("Reactive Stream specification")
        }
        org.jetbrains.compose.web.dom.Text(" made on top of coroutines and channels for Kotlin.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("aim of this article")
        }
        org.jetbrains.compose.web.dom.Text(" is to take you through why Kotlin Flow was designed, some basics, differences between other reactive stream specifications and multi-platform [obviously everyone ❤️ multiplatform these days].")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://www.youtube.com/watch?v=_hfBv0a09Jc") {
            org.jetbrains.compose.web.dom.Text("It’s recommended to have some background of reactive programming or coroutines to easily relate to this article")
        }
        org.jetbrains.compose.web.dom.Text(" 😊")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("history-behind-flow") }) {
        org.jetbrains.compose.web.dom.Text("History behind Flow ⏳")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The history is spread across the internet but long story short, after the launch 🚀 of coroutines, people started enjoying coroutines due to its simplicity and structured concurrency.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Also coroutines did give an easy way to prevent callback hell but it didn’t provide us with any reactive APIs similar to RxJava.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This combined with growing usage 📈of Kotlin, people started expressing their interest to have a pure Kotlin implementation of RxJava to leverage the power of Kotlin like type system, coroutines, etc combined with Kotlin multiplatform people expressed to have the ability to use reactive programming for all platforms i.e shared implementation for JVM, JS and Native.")
    }
    org.jetbrains.compose.web.dom.Blockquote {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("At the end it’s important that any new library raises the bar compared to existing ones and is not just a replica with slight improvements")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("And Kotlin Flow does raise the bar 📶 and that’s why Flow came into the picture with growing needs from the community plus a scope to raise the bar.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("kotlin-flow") }) {
        org.jetbrains.compose.web.dom.Text("Kotlin Flow 🔀")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You know this by now, Kotlin flow is reactive (i.e. async handling of data streams), and cold ❄️ (i.e. it won’t start emitting events until there’s an observer) and it’s part of Kotlin ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/Kotlin/kotlinx.coroutines") {
            org.jetbrains.compose.web.dom.Text("coroutines library")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    org.jetbrains.compose.web.dom.Blockquote {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("In simple words, you can think of it like a Collection and all of the collection operators [like ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("map")
            }
            org.jetbrains.compose.web.dom.Text("] except it’s cold ❄ in nature")
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("what-s-so-special-about-kotlin-flow") }) {
        org.jetbrains.compose.web.dom.Text("What’s so special about Kotlin Flow")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Null safety in streams")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Interoperability between other reactive streams and coroutines")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Supports Kotlin multiplatform")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("No special handling for back pressure [thanks to coroutines]")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Fewer and simple operators [because single operator can handle synchronous and asynchronous logic — we will look into this in next article]")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Perks of structured concurrency 🧱")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("basics") }) {
        org.jetbrains.compose.web.dom.Text("Basics")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Flow is similar to a list of items, it has all sorts of operators like map, filter similar to any list or collection except it is cold ❄️ in nature and is only executed when terminal operator is called.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("There are ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://kotlin.github.io/kotlinx.coroutines/kotlinx-coroutines-core/kotlinx.coroutines.flow/-flow/") {
            org.jetbrains.compose.web.dom.Text("various ways to build a flow using flow builders")
        }
        org.jetbrains.compose.web.dom.Text(". One of the common is using flow builder function ⬇️")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://pl.kotl.in/H9hXUVIVt") {
            org.jetbrains.compose.web.dom.Text("Run this snippet in Kotlin Playground")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The following sequence diagram shows the order of events for the sample code above where the flow is not executed i.e value is not emitted until the terminal function collect is called.")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.graphics.Image("/images/articles/go-with-the-kotlin-flow/1iIq-zG_qRfP9swMdf6w6Kw.webp", "")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The collector is the ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/Kotlin/kotlinx.coroutines/blob/master/kotlinx-coroutines-core/common/src/flow/Flow.kt#L160") {
            org.jetbrains.compose.web.dom.Text("Flow")
        }
        org.jetbrains.compose.web.dom.Text(" interface with a single ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("suspend")
        }
        org.jetbrains.compose.web.dom.Text(" function collect which is the terminal operator.")
    }
    org.jetbrains.compose.web.dom.Pre { org.jetbrains.compose.web.dom.Code(attrs = { classes("language-kotlin") }) { org.jetbrains.compose.web.dom.Text("public interface Flow<out T> {    \n    public suspend fun collect(collector: FlowCollector<T>)\n}\n") } }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("and emitter is FlowCollector with a single ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("suspend")
        }
        org.jetbrains.compose.web.dom.Text(" function called emit")
    }
    org.jetbrains.compose.web.dom.Pre { org.jetbrains.compose.web.dom.Code(attrs = { classes("language-kotlin") }) { org.jetbrains.compose.web.dom.Text("public interface FlowCollector<in T> {  \n    public suspend fun emit(value: T)\n}\n") } }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Internally, the whole mechanism of collector and emitter is just about calling functions on both the sides. The suspend keyword is what adds the magic 🔮")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("sprinkle-some-coroutines") }) {
        org.jetbrains.compose.web.dom.Text("Sprinkle some coroutines 🤏")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The best part about Flow is its interoperability with coroutines because both the collect and emit are ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("suspend")
        }
        org.jetbrains.compose.web.dom.Text(" functions 😍")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("That means the flow builder can contain any type of asynchronous heavy operation like loading from the database ⬇️")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://pl.kotl.in/VQvIAlsJk") {
            org.jetbrains.compose.web.dom.Text("Run this snippet in Kotlin Playground")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You can apply all sorts of operators similar to lists before the terminal operator collect. You can find the list of operators ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://kotlin.github.io/kotlinx.coroutines/kotlinx-coroutines-core/kotlinx.coroutines.flow/-flow/index.html") {
            org.jetbrains.compose.web.dom.Text("here")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Since Flow is built on top of coroutines, it borrows the same ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/@elizarov/structured-concurrency-722d765aa952") {
            org.jetbrains.compose.web.dom.Text("structured concurrency")
        }
        org.jetbrains.compose.web.dom.Text(" which we know and love ❤️")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("ideology-of-flow") }) {
        org.jetbrains.compose.web.dom.Text("Ideology of Flow")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Flow follows following principles or ideology for a similar API:")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("1-context-preservation") }) {
        org.jetbrains.compose.web.dom.Text("1. Context preservation")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The context is encapsulated and it’s never allowed to go downstream ⬇️. There is only one way to ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("change the context of a flow")
        }
        org.jetbrains.compose.web.dom.Text("; using the flowOn operator that changes the upstream ⬆️ context [basically everything above the flowOn function]")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This avoids the confusion of which thread your code is exactly going to run on.")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://pl.kotl.in/YpYULV62b") {
            org.jetbrains.compose.web.dom.Text("Run this snippet in Kotlin Playground")
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("2-exception-transparency") }) {
        org.jetbrains.compose.web.dom.Text("2. Exception Transparency")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Flow implementations never catch or handle exceptions that occur in downstream ⬇️ flows, they catch only for upstream ⬆️ using catch operators; this is again due to ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("context preservation.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Actually there is no onError 😅, there is only collect one single thing for Flow making it transparent to catch them and a single place where you receive all types of state [either success 🎉 or failure 🙅‍♂️].")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This makes it super obvious to always handle all the cases and most likely your code would look like this ⬇️ [sample just for reference]")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://pl.kotl.in/x6vyrn1Lx") {
            org.jetbrains.compose.web.dom.Text("Run this snippet in Kotlin Playground")
        }
    }
    org.jetbrains.compose.web.dom.Blockquote {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Confused when to use suspend and when to use Flow for a function? 🤷‍♂️")
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.Text("Use suspend for one-shot operations like insert operation or a network operation and use Flow<T> to get stream of data like getting updates on data changes in the database.")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("testing") }) {
        org.jetbrains.compose.web.dom.Text("Testing")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("As mentioned above, Flow is pretty similar to a list but cold 🥶 hence testing is pretty easy. runBlocking is used to run the coroutine in a blocking fashion, it’s mainly used in tests.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The take operator returns the specified number of values. The key is toList extension function which converts Flow to List 🎉 hence making it super easy to assert ⬇️")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://pl.kotl.in/NBIB9UQBg") {
            org.jetbrains.compose.web.dom.Text("Run this snippet in Kotlin Playground")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Note: runBlocking works for most of the cases except some cases and it’s recommended to use runBlockingTest instead, you can read more about it ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://craigrussell.io/2019/11/unit-testing-coroutine-suspend-functions-using-testcoroutinedispatcher/") {
            org.jetbrains.compose.web.dom.Text("here")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("flow-vs-rxjava-vs-livedata-android") }) {
        org.jetbrains.compose.web.dom.Text("Flow vs RxJava vs LiveData [Android]")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("livedata") }) {
        org.jetbrains.compose.web.dom.Text("LiveData")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We can just ignore LiveData from this discussion since it’s not a reactive library. It’s just a basic implementation of observer — subscriber pattern tuned for Android.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We will talk about this in another article specific to Android 🤖")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("flow-vs-other-reactive-libraries") }) {
        org.jetbrains.compose.web.dom.Text("Flow vs other reactive libraries")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Honestly all the reactive libraries offer the same functionality since all of them follow the same “Reactive Stream specifications”. Hence whatever you choose functionally it should satisfy craving of your project.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The difference lies in the little things 🐥like:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("The developer experience")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("The developer ecosystem of other libraries supporting Flow and more and more people discussion or talking about it which is growing pretty rapidly for Flow")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Support for multiplatform")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Easier to switch to different roles which use Kotlin language like you use Kotlin and coroutines with Android or backend making it easier to switch roles")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("And most important if you or your team is comfortable with it")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("conclusion") }) {
        org.jetbrains.compose.web.dom.Text("Conclusion")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("That’s it for this article! I personally love ❣️Kotlin coroutines — the structured concurrency and the whole idea of Flow and the advantages it brings.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("That said it’s still gonna take some time for the ")
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("few things")
        }
        org.jetbrains.compose.web.dom.Text(" to lose the experimental tag and bring more operators and other cool stuff like ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/Kotlin/kotlinx.coroutines/pull/1354") {
            org.jetbrains.compose.web.dom.Text("DataFlow")
        }
        org.jetbrains.compose.web.dom.Text(", more multiplatform support.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The next articles we will go deeper with Flow and cover various other areas of it 😍")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("read-more") }) {
        org.jetbrains.compose.web.dom.Text("Read more")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://www.youtube.com/watch?v=tYcqn48SMT8") {
                org.jetbrains.compose.web.dom.Text("Asynchronous data streams with Kotlin Flow by Roman Elizarov — YouTube")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://kotlin.github.io/kotlinx.coroutines/kotlinx-coroutines-core/kotlinx.coroutines.flow/-flow/") {
                org.jetbrains.compose.web.dom.Text("Flow documentation [it is really detailed with examples]")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/AkshayChordiya/News") {
                org.jetbrains.compose.web.dom.Text("News Android app [showcasing usage of Flow] (a bit biased over here)")
            }
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("Special thanks to")
        }
        org.jetbrains.compose.web.dom.Text(" ")
        com.varabyte.kobweb.silk.components.navigation.Link("http://medium.com/@JvmName") {
            org.jetbrains.compose.web.dom.Em {
                org.jetbrains.compose.web.dom.Text("Parth Padgaonkar")
            }
        }
        org.jetbrains.compose.web.dom.Text(" ")
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("and")
        }
        org.jetbrains.compose.web.dom.Text(" ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/@sofia.perez.salvo") {
            org.jetbrains.compose.web.dom.Em {
                org.jetbrains.compose.web.dom.Text("Sofía Pérez")
            }
        }
        org.jetbrains.compose.web.dom.Text(" ")
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("for reviewing this article")
        }
    }
}
